import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { unstable_composeClasses as composeClasses } from '@material-ui/unstyled';
import experimentalStyled from '../styles/experimentalStyled';
import useThemeProps from '../styles/useThemeProps';
import { getAccordionDetailsUtilityClass } from './accordionDetailsClasses';

var overridesResolver = function overridesResolver(props, styles) {
  return styles.root || {};
};

var useUtilityClasses = function useUtilityClasses(styleProps) {
  var classes = styleProps.classes;
  var slots = {
    root: ['root']
  };
  return composeClasses(slots, getAccordionDetailsUtilityClass, classes);
};

var AccordionDetailsRoot = experimentalStyled('div', {}, {
  name: 'MuiAccordionDetails',
  slot: 'Root',
  overridesResolver: overridesResolver
})(function (_ref) {
  var theme = _ref.theme;
  return {
    /* Styles applied to the root element. */
    padding: theme.spacing(1, 2, 2)
  };
});
var AccordionDetails =
/*#__PURE__*/
React.forwardRef(function AccordionDetails(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiAccordionDetails'
  });

  var className = props.className,
      other = _objectWithoutPropertiesLoose(props, ["className"]); // TODO: convert to simple assignment after the type error in defaultPropsHandler.js:60:6 is fixed


  var styleProps = _extends({}, props);

  var classes = useUtilityClasses(styleProps);
  return (
    /*#__PURE__*/
    React.createElement(AccordionDetailsRoot, _extends({
      className: clsx(classes.root, className),
      ref: ref,
      styleProps: styleProps
    }, other))
  );
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object
} : void 0;
export default AccordionDetails;